// extracted by mini-css-extract-plugin
module.exports = {"container":"Decibel_container__2GEsp","chartContainer":"Decibel_chartContainer__3e19n","formulaDescription":"Decibel_formulaDescription__32are"};